import dayjs from 'dayjs';

export const getWorkHoursInRange = (start: string, end: string): number => {
  const startDate = dayjs(start).startOf('day');
  const endDate = dayjs(end).startOf('day');

  if (endDate.isBefore(startDate)) return 0;

  const totalDays = endDate.diff(startDate, 'day') + 1;

  const fullWeeks = Math.floor(totalDays / 7);
  let workdays = fullWeeks * 5;

  const remainingDays = totalDays % 7;
  const startDayOfWeek = startDate.day(); // 0 (Sun) to 6 (Sat)

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < remainingDays; i++) {
    const currentDay = (startDayOfWeek + i) % 7;
    if (currentDay !== 0 && currentDay !== 6) {
      // eslint-disable-next-line no-plusplus
      workdays++;
    }
  }

  return workdays * 8;
};
